import { Search } from '@/DTOS/Offer/Search';
import request from '../../utils/request';

const OfferService = {
  search: (search: Search) => {
    return request('/offer/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  searchComment: (search: Search) => {
    return request('/offer/searchComment', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    formData: {
      companyId: any;
      accountSaleId: any;
      date: any;
      dateStart: any;
      dateEnd: any;
      datePeriod?: any;
      acquisitionType: any;
      isExpedite: boolean;
      enumOfferStatusId: any;
      status: any;
      intervention: any;
      hasUnlimitedInterventions: any;
      interventionPriceOnRequest?: any;
      offerWorkPlaceItems: any;
      offerLaborExtras: any;
      offerComments?: any;
    }
  ) => {
    return request('/offer/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          accountSaleId: formData.accountSaleId,
          companyId: formData.companyId,
          date: formData.date,
          dateStart: formData.dateStart,
          dateEnd: formData.dateEnd,
          datePeriod: formData.datePeriod,
          acquisitionType: formData.acquisitionType,
          isExpedite: formData.isExpedite,
          enumOfferStatusId: formData.enumOfferStatusId,
          status: formData.status,
          intervention: formData.intervention,
          hasUnlimitedInterventions: formData.hasUnlimitedInterventions,
          interventionPriceOnRequest: formData.interventionPriceOnRequest,
          offerWorkPlaceItems: formData.offerWorkPlaceItems,
          offerLaborExtras: formData.offerLaborExtras,
          offerComments: formData?.offerComments,
        },
      }),
    });
  },

  preview: (
    id: any,
    formData: {
      acquisitionType?: any;
      companyId?: any;
      accountSale: any;
      accountSaleId: any;
      enumOfferStatusId?: any;
      number?: any;
      date?: any;
      dateStart?: any;
      dateEnd?: any;
      remarks?: any;
      datePeriod?: any;
      company?: any;
      isExpedite?: any;
      intervention?: any;
      hasUnlimitedInterventions: any;
      enumOfferStatus?: any;
      offerWorkPlaceItems?: any;
      offerLaborExtras?: any;
    }
  ) => {
    return request(
      '/offer/preview',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          request: {
            id: id,
            companyId: formData.companyId,
            accountSaleId: formData.accountSaleId,
            accountSale: formData.accountSale,
            acquisitionType: formData.acquisitionType,
            intervention: formData.intervention,
            hasUnlimitedInterventions: formData.hasUnlimitedInterventions,
            isExpedite: formData.isExpedite,
            enumOfferStatusId: formData.enumOfferStatusId,
            number: formData.number,
            date: formData.date,
            dateStart: formData.dateStart,
            dateEnd: formData.dateEnd,
            remarks: formData.remarks,
            company: formData?.company,
            datePeriod: formData.datePeriod,
            enumOfferStatus: formData.enumOfferStatus,
            offerWorkPlaceItems: formData.offerWorkPlaceItems,
            offerLaborExtras: formData.offerLaborExtras,
          },
        }),
      },
      true
    );
  },

  print: (search: Search) => {
    return request(
      '/offer/print',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: { ...search } }),
      },
      true
    );
  },

  downloadFile: (/** @type {any} */ formData: any) => {
    return request(
      '/offer/downloadFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: formData,
      },
      true
    );
  },
};

export default OfferService;
